import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import FAQ from '../../components/HowItWorks/FAQ';
import WhatAreVcoinsHeroSection from '../../components/HowItWorks/WhatAreVcoinsHeroSection';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { whatAreVcoins } from '../../components/HowItWorks/AccordionContent';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:whatAreVcoinsPage.headerTitle.earnVcoins',
    title: 'howItWorks:whatAreVcoinsPage.howToEarn',
    subtitle: 'howItWorks:whatAreVcoinsDescriptions.howToEarn',
    media: '/static/animations/engage.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:whatAreVcoinsPage.headerTitle.spendVcoins',
    title: 'howItWorks:whatAreVcoinsPage.howToSpend',
    subtitle: 'howItWorks:whatAreVcoinsDescriptions.howToSpend',
    media: '/static/animations/spend.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 3,
    headerTitle: 'howItWorks:whatAreVcoinsPage.headerTitle.theFuture',
    title: 'howItWorks:whatAreVcoinsPage.future',
    subtitle: 'howItWorks:whatAreVcoinsDescriptions.future',
    media: '/static/animations/future.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>
        {t('howItWorks:whatAreVcoinsPage.title')}
      </BrowserPageTitle>
      <Container
        fluid
        className="d-flex align-items-center position-relative px-0"
      >
        <WhatAreVcoinsHeroSection />
      </Container>
      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            picture={howTo.picture}
          />
        ),
      )}

      <FAQ page={whatAreVcoins} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works/what-are-vcoins',
  });
  return { ...getTranslations };
};

export default Index;
